import React from 'react'
import { Box, TextField, Button, useTheme, useMediaQuery } from '@mui/material'
import { CollapsibleInputCard } from '../../../components/_WMS/CollapsibleInputCard'

interface QuantitySectionProps {
  quantityInputRef: React.RefObject<HTMLInputElement>
  localQuantity: string
  handleQuantityChange: (value: string) => void
  quantityValidated: boolean
  handleValidateQuantity: () => void
  handleEditQuantity: () => void
  sharedState: {
    cantidad: number | null
    selectedBatch?: { quantity?: number }
    availableStock?: number
  }
}

export const QuantitySection: React.FC<QuantitySectionProps> = ({
  quantityInputRef,
  localQuantity,
  handleQuantityChange,
  quantityValidated,
  handleValidateQuantity,
  handleEditQuantity,
  sharedState
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const maxQuantity = sharedState.selectedBatch
    ? (sharedState.selectedBatch.quantity || 0)
    : (sharedState.availableStock || 0)

  const hasQuantityError = Boolean(localQuantity && parseInt(localQuantity) > maxQuantity)

  const getQuantityLabel = () => {
    if (sharedState.selectedBatch) {
      const batchInfo = sharedState.selectedBatch
      return `Cantidad (Lote: ${(batchInfo as any).batchNumber || 'N/A'} - Máx: ${maxQuantity})`
    }
    return `Cantidad (Máx: ${maxQuantity})`
  }

  return (
    <Box mb={1}>
      <CollapsibleInputCard
        title="Cantidad a Reubicar"
        isValidated={quantityValidated}
        validationFailed={hasQuantityError}
        onEdit={handleEditQuantity}
        isMobile={isMobile}
        expandedContent={
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
            <TextField
              inputRef={quantityInputRef}
              label={getQuantityLabel()}
              type="number"
              variant="outlined"
              fullWidth
              value={localQuantity}
              onChange={(e) => handleQuantityChange(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleValidateQuantity()
                }
              }}
              placeholder={`Máximo: ${maxQuantity}`}
              inputProps={{
                min: 1,
                max: maxQuantity
              }}
              error={hasQuantityError}
              helperText={hasQuantityError ? `La cantidad no puede ser mayor a ${maxQuantity}` : ''}
              style={{
                marginRight: isMobile ? 0 : theme.spacing(1),
                marginBottom: isMobile ? theme.spacing(2) : 0
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleValidateQuantity}
              disabled={!localQuantity.trim() || parseInt(localQuantity) <= 0}
              fullWidth={isMobile}
              style={{ minWidth: isMobile ? 'auto' : '100px' }}
            >
              Validar
            </Button>
          </Box>
        }
        collapsedSummary={`Cantidad: ${sharedState.cantidad} unidades`}
      />
    </Box>
  )
}